module.exports = __webpack_public_path__ + "static/img/kehu.117804de.png";